import { Box, styled, Typography } from '@mui/material'
import type { FC } from 'react'
import { useParams } from 'react-router-dom'

import { COLORS, unit } from '@hcr/pwa/components'

import { useServicesQuery } from '../../../hooks'
import type { ServicesPathParams } from '../../../models'
import {
  createLink,
  createServicesContent,
  isNotUndefinedOrEmptyPathParam,
  isUndefinedOrEmptyPathParam,
} from '../../../utils'
import { LayoutNavigation, LayoutNavigationError404, LayoutNavigationLoading } from '../../common'

import { ServicesEmpty } from './ServicesEmpty'

const servicesContent = createServicesContent({ createLink, slidesMargin: unit(6.5) })

export const Services: FC = () => {
  const params = useParams<ServicesPathParams>()

  const services = useServicesQuery(
    { destinationId: String(params.destinationId) },
    { enabled: isNotUndefinedOrEmptyPathParam(params.destinationId) }
  )

  if (isUndefinedOrEmptyPathParam(params.destinationId)) {
    return <ServicesEmpty />
  }

  if (services.isError) {
    return <LayoutNavigationError404 showContextMenuButton />
  }

  if (services.isSuccess) {
    return (
      <LayoutNavigation showContextMenuButton>
        <Container>
          <Content data-testid='service-page-content-wrapper'>
            <Header>
              <Typography variant='headlineL'>{services.data.title}</Typography>
              <Typography variant='bodyL'>{services.data.description}</Typography>
            </Header>
            <Carousel>{services.data.content.map(servicesContent)}</Carousel>
          </Content>
        </Container>
      </LayoutNavigation>
    )
  }

  return <LayoutNavigationLoading showContextMenuButton />
}

const Container = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: ${unit(9)};
  padding-top: ${unit(19)};
  background-color: ${COLORS.white};
`

const Content = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: ${unit(9)};
  padding: ${unit(6.5)};
  background-color: ${COLORS.white};
`

const Header = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: ${unit(4)};
`

const Carousel = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: ${unit(7.5)};
  padding-bottom: ${unit(17)};
`
